import React from 'react'
import style from "../layout.module.css"

export function SimpleLayout(props: { children: React.ReactNode }) {
    const { children } = props;

    return (
        <div className={style.layoutContainer}>
            <main className={style.mainContentContainer}>{children}</main>
        </div>
    )
}